import {openDB, IDBPDatabase} from 'idb';

const DB_NAME = 'attachment-cache';
const DB_VERSION = 1;
const STORE_NAME = 'files';
const EXPIRATION_MS = 24 * 60 * 60 * 1000; // 1 den
const MAX_CACHE_ITEMS = 100;

async function openAttachmentDB() {
    return await openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        }
    });
}

async function cleanupCache(db: IDBPDatabase) {
    const keys = await db.getAllKeys(STORE_NAME);
    const records = await Promise.all(keys.map(key => db.get(STORE_NAME, key)));

    const validEntries = keys
        .map((key, index) => {
            const record = records[index];
            return record && typeof record.timestamp === 'number'
                ? {key, timestamp: record.timestamp}
                : null;
        })
        .filter((entry): entry is { key: IDBValidKey, timestamp: number } => entry !== null);

    validEntries.sort((a, b) => a.timestamp - b.timestamp);

    while (validEntries.length > MAX_CACHE_ITEMS) {
        const oldest = validEntries.shift();
        if (oldest) {
            await db.delete(STORE_NAME, oldest.key);
        }
    }
}


export async function cacheBlob(key: string, blob: Blob) {
    const db = await openAttachmentDB();
    await db.put(STORE_NAME, {blob, timestamp: Date.now()}, key);
    await cleanupCache(db);
}

export async function getCachedBlob(key: string): Promise<Blob | null> {
    const db = await openAttachmentDB();
    const record = await db.get(STORE_NAME, key);
    if (!record) return null;

    if (Date.now() - record.timestamp > EXPIRATION_MS) {
        await db.delete(STORE_NAME, key);
        return null;
    }

    return record.blob;
}
